<script setup>
import PrinterSelect from "../layout/printer-select.vue";
import {ref} from "vue";
import helpers from "@/lib/helpers";
import {useDocs} from "@/lib/useDocs";

const {printDoc} = useDocs();

const props = defineProps({
  value: {
    type: Object,
    required: true
  }
})

const printer = ref()
const save_printer = ref(false)
const printer_select = ref()

const carrier_label_preview = () => {
  window.open(props.value._links.carrier_label_preview_url.href, '_blank')
}

const carrier_label_print = async () => {
  let all = false
  if (props.value.group_packages && props.value.group_packages.length)
    all = await helpers.confirm('Print all package labels?')

  printDoc(printer.value, 'LabelCarrier', props.value._links.carrier_label_url, 1, false, {
    printer_type: 'printers.carrier',
    save_printer: save_printer.value,
    all
  }).then(() => {
    if (save_printer.value)
      printer_select.value.loadSettings()
  })
}

</script>

<template>
  <div v-if="value.label_type === 'ZPL'">
    <b-input-group>
      <printer-select v-model="printer" type="LabelCarrier" setting="printers.carrier"
                      ref="printer_select"/>
      <b-input-group-append>
        <b-btn size="sm" variant="outline-secondary" @click="carrier_label_print">
          <font-awesome-icon class="px-2" :icon="['fas', 'print']"/>
        </b-btn>
      </b-input-group-append>
      <b-input-group-append>
        <b-btn size="sm" variant="outline-secondary" @click="carrier_label_preview">
          <font-awesome-icon class="px-2" :icon="['far', 'file-pdf']"/>
        </b-btn>
      </b-input-group-append>
    </b-input-group>
    <div class="mt-2">
      <b-check switch v-model="save_printer">Save as default printer</b-check>
    </div>
  </div>
  <b-btn @click="carrier_label_preview" v-else block size="sm" variant="outline-secondary" class="my-2">Label PDF</b-btn>
</template>

<style scoped>

</style>